import React from 'react';
import Button from '../ui/Button';

export default function BroadcastBanner({ broadcast, onReview }) {
  if (!broadcast) return null;
  const severityClass =
    broadcast.severity === 'critical'
      ? 'sp-alert--critical'
      : broadcast.severity === 'warning'
        ? 'sp-alert--high'
        : 'sp-alert--info';
  return (
    <div className={`sp-alert ${severityClass} flex items-center justify-between flex-wrap gap-4`}>
      <div>
        <p className="sp-value" style={{ fontWeight: 600 }}>
          {broadcast.title}
        </p>
        <p className="text-xs sp-muted">Acknowledgment required for this announcement.</p>
      </div>
      <Button size="sm" variant="secondary" onClick={onReview}>
        Review announcement
      </Button>
    </div>
  );
}
